import axios from 'axios';
import router from '../router'

// Create globar Axios instance
const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_BASEURL,
    withCredentials: true,
    timeout: process.env.VUE_APP_API_TIMEOUT,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

let isAlreadyFetchingAccessToken = false
let subscribers = []

// Interceptor for expired token
axiosInstance.interceptors.response.use(function (response) {
    return response;
  }, function (error) {

    if (!error.response || (error.response.status === 408 || error.code === 'ECONNABORTED')) {
        alert("\r\nServer connection timout!\r\n\r\nEither your Internet connection is down or there is a problem with the server. Please wait a few moments and try again.  If the problem persists, contact technical support.");
        console.log(`API connection timeout to url ${error.config.url}`)
    }

    const { config, response: { status } } = error;
    const originalRequest = config;

    if (status === 401 && !config.url.includes('auth/refresh')) {
        if (!isAlreadyFetchingAccessToken) {
            isAlreadyFetchingAccessToken = true;
            axiosInstance
                .get('/auth/refresh')
                .then(function () {
                    console.log('Token Cookie Refreshed');
                    isAlreadyFetchingAccessToken = false;
                    onAccessTokenFetched();
                })
                .catch(function () {
                    console.log('Token Cookie Refresh Failed.  Redirect to Login.');
                    let queryString = null;
                    if (router.currentRoute.path != '/') {
                        queryString = { query: { 'r' : encodeURIComponent(router.currentRoute.path) } };
                    }
                    router.push({ name: 'Login', queryString });
                })
        }
  
        const retryOriginalRequest = new Promise((resolve) => {
            addSubscriber( () => {
            resolve(axios(originalRequest));
            })
        });
        return retryOriginalRequest;
    }
    return Promise.reject(error);
});

function onAccessTokenFetched() {
    subscribers = subscribers.filter(callback => callback());
}

function addSubscriber(callback) {
    subscribers.push(callback);
}

export default axiosInstance;